exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}html{-ms-touch-action:none}body,html{-webkit-text-size-adjust:none;margin:0;height:100%;font-size:14px}body ::-webkit-scrollbar,html ::-webkit-scrollbar{width:0}ol,ul{list-style:none}a{color:#32adc6;text-decoration:none}a,button{-webkit-tap-highlight-color:rgba(0,0,0,0)}button,input,textarea{-webkit-appearance:none;appearance:none;border:none;outline:none}input:active,select:active,textarea:active{border:none}input,select,textarea{font-size:14px}img{border:none}input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{color:#999}input:-moz-placeholder,input::-moz-placeholder,textarea:-moz-placeholder,textarea::-moz-placeholder{color:#999}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#999}::-webkit-scrollbar{width:0;height:0}.visitor_scroll::-webkit-scrollbar{width:15px!important;height:100%!important}.el-image{width:100%;height:100%}.el-scrollbar__bar{z-index:3}.el-scrollbar__bar.is-vertical{width:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/components/less/reset.less
// module id = 919
// module chunks = 0